import { createAsyncSliceWithDataAndQuery } from 'store/createAsyncSliceWithDataAndQuery';
import { getTaxCertificationsAsync } from '../../../API/vendorDashboard/VendorAPI';
import { createDefaultSearchOrdersTaxReqSettingsData } from '../../../types/vendorDashboard/ISearchOrderTaxCertReqSettingsData';
import { createDefaultVendorTaxCertificationsData } from '../../../types/vendorDashboard/IVendorTaxCertifications';

export const { slice: vendorTaxCertificationsSlice, asyncAction: getTaxCertificationsAsyncAction } =
  createAsyncSliceWithDataAndQuery('vendorTaxCertificationsSlice', getTaxCertificationsAsync, {
    taxCerts: createDefaultVendorTaxCertificationsData(),
    setting: createDefaultSearchOrdersTaxReqSettingsData(),
  });
